import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColorRoll: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"color-roll, paint-roller"} maskId="square-filled-radius-0-stroke-1-IconColorRoll"><path d="M6 3H21V11H6V7.5H4V13H13.5V15.5415C14.9189 15.7795 16 17.0135 16 18.5V22H15V18.5C15 17.3954 14.1046 16.5 13 16.5C11.8954 16.5 11 17.3954 11 18.5V22H10V18.5C10 17.0135 11.0811 15.7795 12.5 15.5415V14H3V6.5H6V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconColorRoll;
